import { AxiosPromise } from 'axios'

import { createLoginClient } from './createLoginClient'
import { postLogin } from './methods'
import { LoginClient as BaseLoginClient } from './types'
import {
  LoginClientOptions,
  GetLoginResponse,
} from './types/LoginClient'

export default function LoginClient(options?: LoginClientOptions): LoginClient {
  const commonOptions = {}

  return createLoginClient({
    ...commonOptions,
    ...options,
    methods: {
      postLogin,
    },
  })
}

export type LoginClient = BaseLoginClient & {
  readonly postLogin: (email: string, password: string) => AxiosPromise<GetLoginResponse>
}
